import React, { useEffect, useState } from 'react'
import CustomdropDown from './customdropDown'
import axios from 'axios'
import { Grid } from '@mui/material'
import _ from 'lodash'
import { useDispatch } from 'react-redux'
import { setSnackbar } from '../../hooks/snackBar/reducers'

const State = ({formik, stateId}) => {
  const dispatch = useDispatch()

    const [stateList, setStateList] = useState([])
    const getStateList = (id) =>{
        axios.post('/v1/states',{country_id:id}).then(res=>{
          setStateList(res.data);
          _.filter(res.data,val=>val.id===stateId).map(val=>formik.setFieldValue('state',val))
        })
        .catch(err=>{
          dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
        })
      }

    useEffect(()=>{
      if( formik.values.country){
         getStateList(formik.values.country.id)
      }
      else{
        setStateList([])
        formik.setFieldValue('state', null)
      }
      },[formik.values.country])
      
  return (
    <Grid>
        <CustomdropDown id='state' data={stateList}
          optionLabel={(option)=>option.name}
          value={formik.values.state} 
          onchange={(e,value)=>{formik.setFieldValue('state', value)}} 
          optionEqual={(option, value) => option.name === value.name} 
          placeholder="Select State"
          helperText={formik.touched.state && formik.errors.state}
          errorMsg={formik.touched.state && Boolean(formik.errors.state)} 
          title="State *"
     />
    </Grid>
  )
}

export default State